<template>
  <!-- currency_boxs -->
  <div class="boxs">
    <div class="nav"
         :style="{'backgroundColor':isHome ?navBg:!isHome?'#fff':'','color':navBg && isHome?'#000':'#fff'}">
      <div class="box">
        <div class="logo"
             @click="toIndex">
          <img v-show="isHome && navBg"
               :src="$imgUrl + 'OnlineBusinessSchool/TOP_logo.png'"
               alt="">
          <img v-show="isHome && !navBg"
               :src="$imgUrl+'home/toplogo.png'"
               alt="">
          <img v-show="!isHome"
               :src="$imgUrl+'OnlineBusinessSchool/TOP_logo.png'"
               alt="">
        </div>
        <div class="nav_list">
          <el-menu :text-color="isHome && navBg?'#000':isHome && !navBg?'#fff':'#000'"
                   active-text-color="#DE1F26"
                   router
                   background-color="rgba(0,0,0,0)"
                   class="el-menu-demo"
                   menu-trigger="click"
                   mode="horizontal"
                   :default-active="$route.path"
                   @select="handleSelect">
            <el-menu-item :index="item.path"
                          v-for="(item,index) in list"
                          :key="index">{{item.text}}
              <!-- <div v-if="$route.path == item.path"
                   class="active">
                <div class="line mainBgColor"></div>
              </div> -->
            </el-menu-item>

          </el-menu>
        </div>
        <!-- <div v-if="!isLogin"
             class="login"
             @click="login"
             :style="{color:isHome && navBg?'#000':isHome && !navBg?'#fff':'#000'}"><i class="el-icon-s-custom"></i> 登录</div>
        <el-dropdown v-else
                     @command="dropTap">
          <div class="flexEnd">
            <el-image style="width:36px;height:36px;border-radius: 50%;"
                      :src="info.headImg"></el-image>
            <span style="margin-left:10px"
                  :style="{'color':isHome && navBg?'#000':isHome && !navBg?'#fff':'#000'}">{{info.userName.length>=3?info.userName.substr(0,3)+'...':info.userName}}</span>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item :command="index"
                              v-for="(item,index) in dropList"
                              :key="index">{{item.text}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
        <div style="cursor: pointer;background:#409EFF;border-radius: 4px;padding:4px 10px 6px 10px;"><a :style="{'color':'#fff','text-decoration': 'none','font-size':'14px'}"
             :href="isMobile()?'http://admin-h5.jclingshou.com':'https://new-retail-console.jclingshou.com'"
             target=_blank>进入管理平台 <i :style="{'color':'#fff'}"
               class="el-icon-monitor"></i></a> </div>
      </div>
    </div>
    <login :dialogVisible="dialogVisible"
           @close="closelogin"></login>
  </div>
</template>

<script>
import {
  fenceList, logout
} from '../api/api.js'
export default {
  name: 'bottom_pass',
  props: {
    navBg: {
      type: String
    },
    isHome: {
      type: Boolean,
      default: { return: false }
    }
  },
  data () {
    return {
      /* <div class="container">

      <iframe src="http://example.com"
              frameborder="0"
              width="100%"
              height="100%"></iframe>

    </div>*/
      // { text: '我的主页', path: '/My' }, { text: '个人设置', path: '/Set' },
      dropList: [{ text: '退出登录', path: '/' }],
      activeIndex: 1,
      list: [
        { text: '首页', path: '/' },
        { text: '线上商学院', path: '/OnlineBusinessSchool' },
        { text: '零售培训', path: '/RetailTraining' },
        { text: '咨询顾问', path: '/Consultant', },
        { text: '零售老板圈', path: '/Bosscircle' },
        { text: '数字产品', path: '/TechProduct' },
        { text: '合作案例', path: '/Cooperationcases' },
        { text: 'APP下载', path: '/download' },
        { text: '关于我们', path: '/aboutUs' }
      ],
      dialogVisible: false,
      isLogin: false,
      info: {}
    }
  },
  created () {
    if (localStorage.getItem('accessToken') && localStorage.getItem('accessToken') != '') {
      this.isLogin = true;
      this.info = JSON.parse(localStorage.getItem('info'))
    } else {
      this.isLogin = false;
    }
  },
  methods: {
    isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    },
    dropTap (index) {
      console.log(index)
      // if (index != 2) {
      //   this.$router.push(this.dropList[index].path)
      // } else {
      logout().then(res => {
        if (res && res.code == 200) {
          localStorage.clear();
          this.$message({
            showClose: true,
            message: '退出成功!',
            type: 'success'
          });
          setTimeout(() => {
            if (this.$route.path != '/') {
              this.$router.push('/')
            } else {
              window.location.reload()
            }
          }, 500);
        }
      })
      // }
    },
    handleSelect (i) {
      this.list.forEach((item, index) => {
        if (item.path == i) {
          this.activeIndex = index
        }
      })
      console.log(this.activeIndex)
      // this.activeIndex = index;
    },
    toInfo () {
      this.$router.push('/info')
    },
    tabClick (index) {
      this.tabIndex = index;
      this.$emit('tabClick', index)
      if (this.$route.path != '/search') {
        this.$router.push('/search')
      }
    },
    async getData () {
      const res = await fenceList()
      if (res.status != 1) return this.$element.error(res.msg)
      let list = res.result
      list.forEach((item) => {
        if (item.id == sessionStorage.getItem('labelId')) {
          if (item.is_re == 1) {
            this.list = ['推荐', '列表']
            this.$emit('tabClick', 0)
          } else {
            this.$emit('tabClick', 1)
          }
        }
      })
      console.log(sessionStorage.getItem('labelId'))
      list.unshift({
        name: '首页',
        id: -1,
      })
      list.push({
        name: '发布',
        id: -99,
      })
      this.topList = list;

    },
    toPosition () {
      this.$router.push('/position')
    },
    toIndex () {
      this.$router.push('/')
    },
    closelogin () {
      this.dialogVisible = false
    },
    login () {
      // this.$router.push('/login')
      this.dialogVisible = true
    },
    link (item, index) {
      if (index == 0 || index == this.topList.length - 1) {
        if (index == 0) {
          sessionStorage.setItem('labelId', -1)
          this.$router.push('/')
        } else {
          sessionStorage.setItem('labelId', -99)
          this.$router.push('/publish_listings')
        }
      } else {
        console.log(this.$route)
        if (this.param.id == item.id && this.$route.path == '/search') return
        console.log(item)
        sessionStorage.setItem('labelId', item.id)
        var data = encodeURI(JSON.stringify(item))
        data = encodeURI(data) // 第二次加密
        this.$router.push('/search?data=' + data)
        window.location.reload()
      }
    }
  }
}
</script>
<style lang="less" scoped>
/* element组件部分样式强改 */
// .nav:hover {
//   background-color: #fff;
// }
// .el-menu--horizontal > .el-menu-item.is-active {
//   font-size: '30px !important';
// }
.active {
  position: absolute;
  bottom: 4px;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  .line {
    width: 28px;
    height: 2px;
    background-color: #de1f26;
  }
}
.nav_list {
  flex: 1;
}
.nav {
  // background-color: #fff;
  height: 72px;
  position: fixed;
  // min-width: 1200px;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 19;
  .box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    width: 1200px;
    height: 72px;
    margin: 0 auto;
    .logo {
      text-align: left;
      cursor: pointer;
      img {
        width: 138px;
        height: 34px;
      }
    }
    .login {
      text-align: right;
      cursor: pointer;
    }
  }
  // .el-menu {
  //   background-color: 'rgba(0,0,0,0)' !important;
  // }
  .el-menu-item:hover {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-menu.el-menu--horizontal {
    border: none !important;
  }
}
</style>
